import { render, staticRenderFns } from "./HideCompletedSwitch.vue?vue&type=template&id=63633871&scoped=true"
import script from "./HideCompletedSwitch.vue?vue&type=script&lang=js"
export * from "./HideCompletedSwitch.vue?vue&type=script&lang=js"
import style0 from "./HideCompletedSwitch.vue?vue&type=style&index=0&id=63633871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63633871",
  null
  
)

export default component.exports